module.exports = __webpack_public_path__ + "img/1502636314.9a667aa8.jpg";